/* global dagreD3 */
import _ from 'underscore';
import i18n from 'l10n';

require('d3');
require('d3dagre');

export default {
    showDependencyGraph: function () {
        var self = this;
        self.$('#dep').on("click", function () {
            if (self.$('#dag').is(':visible')) {
                self.$('#dag').hide();
                self.$('#dag > svg').html('<g transform="translate(20, 20)"/>');
            } else {
                self.$('#dag').show();
                self.ajaxCall();
            }
        });
    },

    updateGraph: function () {
        if (this.$('#dag').is(':visible')) {
            this.$('#dag').hide();
            this.$('#dag > svg').html('<g transform="translate(20, 20)"/>');
            this.$('#dag').show();
            this.ajaxCall();
        }
    },

    ajaxCall: function () {
        $.ajaxDefaultQ({
            url: `/CampaignCloud/Message/dependencyGraphAround/${this.model.get("id")}`,
            type: 'GET',
            dataType: 'json'
        }).done(data => {
            this.showDependencyGraphData(data);
        });
    },

    showDependencyGraphData: function (graph) {
        _.forEach(graph.nodes, node => {
            var label = node.value.label;
            if (label.id === this.model.get("id")) {
                label.cssclass = "selected";
            }
            var kind = node.kind;
            if (label.label === "") {
                switch (kind) {
                    case "BULK":
                        label.label = i18n.t("message.nonamemessage");
                        break;
                    case "SMART_NOTIFICATION":
                        label.label = i18n.t("message.nonamemessage");
                        break;
                    case "TELLODY_VOUCHER":
                        label.label = i18n.t("voucher.nonameservice");
                        break;
                    case "TELLODY_SURVEY":
                        label.label = i18n.t("survey.noname");
                        break;
                    case "EMAIL_OPTIN":
                        label.label = i18n.t("optin.noTitle");
                        break;
                    case "QUIZ_OPTIN":
                        label.label = i18n.t("optin.noTitle");
                        break;
                }
            }
            if (label.label.length > 30) {
                var t = label.label;
                label.label = t.substring(0, 30) + "…";
                label.title = t;
            }
            var page = kind === "BULK" || kind === "SMART_NOTIFICATION" ? "Message.htm" : "Service.htm";
            label.onmousedown = `location.href = '${page}#' + evt.target.getAttribute('data-id');`;

            switch (kind) {
                //case "BULK": label.label = i18n.t("message.nonamemessage"); break;
                case "SMART_NOTIFICATION":
                    label.iconText = "\ue067";
                    label.iconFont = "iconFont";
                    break;
                case "TELLODY_VOUCHER":
                    label.iconText = "G";
                    label.iconFont = "tellody";
                    break;
                case "TELLODY_SURVEY":
                    label.iconText = "\ue00d";
                    label.iconFont = "iconFont";
                    break;
                case "EMAIL_OPTIN":
                    label.iconText = "\ue08d";
                    label.iconFont = "iconFont";
                    break;
                case "QUIZ_OPTIN":
                    label.iconText = "\ue08d";
                    label.iconFont = "iconFont";
                    break;
                case "INSTANT_WIN":
                    label.iconText = "\ue04f";
                    label.iconFont = "iconFont";
                    break;
                case "PAY_PAL_PAYMENT" :
                    label.iconText = "\uf155";
                    label.iconFont = "FontAwesome";
                    break;
            }
        });


        var svgParent = this.$('#dag > svg');
        var nodes = graph.nodes;
        var links = graph.links;

        var graphElem = svgParent.children('g').get(0);
        var svg = d3.select(graphElem);
        var renderer = new dagreD3.Renderer();
        var layout = dagreD3.layout().rankDir('TB');
        renderer.layout(layout).run(dagreD3.json.decode(nodes, links), svg.append('g'));

        // Adjust SVG height to content
        var main = svgParent.find('g > g');
        var rect = main.get(0).getBoundingClientRect();
        var h = rect.height;
        var w = rect.width;
        var newHeight = h + 40;
        var newWidth = w + 40;
        var maxWidth = svgParent.parent().width();

        const scaledWidth = maxWidth / newWidth;

        if (newWidth <= maxWidth) {
            newHeight = Math.max(80, newHeight);
            newWidth = Math.max(80, newWidth);
        } else {
            newHeight = Math.max(80, newHeight);
            newWidth = maxWidth; //need to scale
            newHeight = newHeight * scaledWidth;
        }
        svgParent.height(newHeight);
        svgParent.width(newWidth);

        if (scaledWidth < 1)
            svg.select('g').attr('transform', `scale(${scaledWidth})`);
    }
};
